import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxMaterialModule } from '@impesa/ngx-core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-kyc-alert-ina',
  standalone: true,
  imports: [CommonModule, NgxMaterialModule, TranslateModule],
  templateUrl: './kyc-alert-ina.component.html',
  styleUrls: ['./kyc-alert-ina.component.scss'],
})
export class KycAlertINAComponent {}
